// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    CHANGE_LIST_SEARCH_REQUEST,
    CHANGE_LIST_SEARCH_SUBUSERS_REQUEST,
} from 'Redux/actionTypes';

// Actions
import {
    changeListSearchResult,
    changeListSearchSubUsersResult,
} from 'Redux/actions';

// Helpers
import { clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* searchListAuditlogs({ payload }) {
    const { filters } = payload
    try {
        let QUERY = `
            query searchAuditlogs ($accountId: String, $entity: EntityAuditLogInput, $action: [String], $opensearch: [String], $username: String, $dateRange: AWSDateTimeRange, $nextToken: String,  $lastRecords: Int) {
                result: searchAuditlogs (accountId: $accountId, entity: $entity, action: $action, opensearch: $opensearch, username: $username, dateRange: $dateRange, nextToken: $nextToken, lastRecords: $lastRecords) {
                    items {
                        id
                        source
                        urlReferrer
                        module
                        method
                        ipAddress
                        platform
                        entityName
                        entityId
                        accountId
                        action
                        newValues
                        parameters
                        updatedBy
                        updatedOn
                        username
                    }
                    nextToken
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            filters,
            endpoints.GRAPHQL_GENERAL,
        );
        if (data.result) yield put(changeListSearchResult(data.result))
        else yield put(changeListSearchResult(null))

    } catch (exc) {
        yield put(changeListSearchResult(null))
        ExceptionManager(exc, 'Modules/activities/.components/changeList/redux/saga', 'searchListAuditlogs');
    }
}

function* searchSubUsers({ payload }) {
    const { companyId } = payload
    try {
        let QUERY = `
        query searchSubUsers ($conditions: [SubUserSearchInput], $sort: [SubUserSortInput], $limit: Int, $offset: Int) {
            result: searchSubUsers (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    id
                    userName
                }
            }
        }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: [
                    {
                        "fields": [
                            "companyId"
                        ],
                        "terms": [companyId],
                        "exact": true,
                        "conditionOperator": "AND"
                    }
                ],
                sort: {
                    field: "userName",
                    order: "ASC"
                },
                limit: 500,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );
        
        if(data?.result.items){
            yield put(changeListSearchSubUsersResult(data?.result?.items))
        }

    } catch (exc) {
        yield put(changeListSearchSubUsersResult([]))
        ExceptionManager(exc, 'Modules/activities/.components/changeList/redux/saga', 'searchSubUsers');
    }
}


function* watchMethods() {
    yield takeEvery(CHANGE_LIST_SEARCH_REQUEST, searchListAuditlogs);
    yield takeEvery(CHANGE_LIST_SEARCH_SUBUSERS_REQUEST, searchSubUsers);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}